<template>
    <div id="attività" class="section attivita" v-if="this.dataLoaded">
        <GridLines />
        <div class="big-title" data-aos="new-animation" data-aos-init="aos-init" >
            <h1 v-html="this.splittedTitle(this.page.attributes.title)"></h1>
        </div>
        <div class="container title-section">
         <h3 v-if="labelTitle">{{ labelTitle }}</h3>
            <h1 data-aos="new-animation" data-aos-init="aos-init" class="animated-title" data-aos-delay="4000" v-html="this.page.attributes.title"></h1>
                    
        </div>
        <div class="container text-section">
            <div class="row">
                <div class="col-md-12 col-lg-6">
<h2>{{this.page.attributes.field_subtitle}}</h2>
                </div>
                <div class="col-md-12 col-lg-6">
                  <p v-html="this.page.attributes.field_description.processed"></p>
                </div>
            </div>
            <div class="sedi">
                <Sedi :dataSedi="this.dataSedi" />
            </div>
        </div>
    </div>
</template>
<script>
import Sedi from './Sedi.vue';
import GridLines from "./GridLines.vue"

export default {
  name: 'section-attivita',
components:{
      Sedi,
      GridLines
  },
  props: {
      dataPages: {
          type: String
      },
      dataSedi: {
          type: String
      }
  },
  data:()=>{
        return {
            idIntroPage:"4f5d56da-0d43-4098-bfc2-696010d632c7",
            page:[],
            dataLoaded:false
        }
  },
    computed:{
labelTitle(){
        if(this.$route.params.lang == "it"){
            return "dove siamo attivi"
        } else {
            return "where we are "
        }
            
    },
    },
methods:{
    splittedTitle: function (value) {
        return value.replace(/(?![^<]*>)[^<]/g, c => `<span>${c}</span>\n`);
    },
    findObjectbyKey(array, key, value){
        for (var i = 0; i < array.length; i++) {
            if (array[i][key] === value) {
                return array[i];
            }
        }
        return null;
    }
},
    mounted(){
        fetch("https://ptnlex-api-prod.interfase.tv/"+this.$route.params.lang+"/jsonapi/node/page", {method: "GET", mode: 'cors'})
        .then(response=>{
            return response.json()
        })
        .then(json=>{
            this.page = this.findObjectbyKey(json.data,"id",this.idIntroPage)
            this.dataLoaded = true
        })
        .catch(function(error) {  
            console.log('Request failed', error)  
        });
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.attivita {
    background: #14182E;
    h1,h2,h3,p {
        color: #fff;
    }
}
.attivita .big-title h1{
    opacity: 0.2;
    transform: translate3d(318%,1230%, 0);
}
.container.title-section {
    padding-top: 4rem;
    padding-bottom: 0rem;
    h1 {
        margin-bottom: 0;
    }
}
.container.text-section{
    padding-top: 2rem;
}
</style>
